document.addEventListener('DOMContentLoaded', function () {
    const fileInput = document.getElementById('PassportAndHuntingLicenseInput');
    const fileLabel = document.querySelector('label[for="PassportAndHuntingLicenseInput"]');
    const fileListContainer = document.getElementById('file-list'); // Container for displaying the list of files
    let selectedFiles = [];

    // Function to handle updating the label and file list
    function updateFileList() {
        const newFiles = Array.from(fileInput.files); // Get newly selected files
        selectedFiles = [...selectedFiles, ...newFiles]; // Append new files to the list

        // Reset the file input so users can select the same file again if needed
        fileInput.value = '';

        // Render the file list and update the label
        renderFileList();
    }

    // Function to render the list of selected files
    function renderFileList() {
        // Clear the file list container
        fileListContainer.innerHTML = '';

        // If there are selected files, display them
        if (selectedFiles.length > 0) {
            selectedFiles.forEach((file, index) => {
                const fileItem = document.createElement('div');
                fileItem.textContent = `${file.name} (${(file.size / 1024).toFixed(2)} KB)`; // Display file name and size

                // Add a "Remove" button for each file
                const removeButton = document.createElement('button');
                removeButton.textContent = 'Fjern';
                removeButton.classList.add('btn', 'btn-danger', 'btn-sm', 'ml-2', 'mt-1');
                removeButton.addEventListener('click', () => removeFile(index)); // Remove file on click

                // Append the file item and the remove button
                fileItem.appendChild(removeButton);
                fileListContainer.appendChild(fileItem);
            });

            // Update the label to reflect the selected files
            fileLabel.textContent = selectedFiles.map(file => file.name).join(', ');
        } else {
            fileLabel.textContent = 'V\u00E6lg filer'; // Default label text
        }
    }

    // Function to remove a file from the list
    function removeFile(index) {
        selectedFiles.splice(index, 1); // Remove the file from the array
        renderFileList(); // Re-render the file list
    }

    // Event listener for when the user selects files
    fileInput.addEventListener('change', updateFileList);

    // Before form submission, append the selected files back to the file input
    document.getElementById('upload-form').addEventListener('submit', (event) => {
        const dataTransfer = new DataTransfer();

        // Add all selected files to the DataTransfer object
        selectedFiles.forEach(file => dataTransfer.items.add(file));

        // Set the file input's files to the DataTransfer's files so they get submitted with the form
        fileInput.files = dataTransfer.files;
    });

    // Initialize the file input state on page load
    renderFileList();
});